import { EApiSortType } from '@/api/apiConstants'
import type { EDietTagFilter } from '@/modules/dietModule/constants/dietTags'

const groupPrefixFilter = createApiRoute(ApiModule.DIETARY, ApiDataModel.FILTER_TAGS)
const groupPrefixMarketing = createApiRoute(ApiModule.DIETARY, ApiDataModel.MARKETING_TAGS)
const groupPrefixDietary = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIETARY_TAGS)

export const apiDietTags = {
	/**
	 * Filters
	 */
	fetchDietFilterTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<{ data: IDietFilterTagModel[]; meta: IApiMetaModel | undefined }> => {
		const { data, meta } = await apiCommon<IDietFilterTag[]>(`${groupPrefixFilter}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
		})
		return { data: data.map(d => DietFilterTag(d)), meta }
	},
	createFilterTag: async (payload: IDietTagCreatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixFilter}`, {
			method: 'POST',
			body: dietTagCreateToJSON(payload),
		})
		return DietFilterTag(data)
	},
	updateFilterTag: async (body: IDietDietaryTag) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixFilter}/${body.id}`, {
			method: 'PUT',
			body,
		})

		return DietFilterTag(data)
	},
	deleteFilterTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixFilter}/${id}`, { method: 'DELETE' })
	},

	/**
	 * Marketing
	 */
	fetchDietMarketingTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<IApiResponseModel<IDietMarketingTagModel[]>> => {
		const { data, meta } = await apiCommon<IDietMarketingTag[]>(`${groupPrefixMarketing}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
		})
		return { data: data.map(d => DietMarketingTag(d)), meta }
	},
	createMarketingTag: async (payload: IDietTagCreatePayload) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixMarketing}`, {
			method: 'POST',
			body: dietTagCreateToJSON(payload),
		})

		return DietMarketingTag(data)
	},
	updateMarketingTag: async (body: IDietDietaryTag) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixMarketing}/${body.id}`, {
			method: 'PUT',
			body,
		})
		return DietMarketingTag(data)
	},
	deleteMarketingTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixMarketing}/${id}`, { method: 'DELETE' })
	},

	/**
	 * Dietary
	 */
	fetchDietaryTags: async (
		page: number = 1,
		perPage: number = 25,
		model_type?: EDietTagFilter,
	): Promise<IApiResponseModel<IDietDietaryTagModel[]>> => {
		const { data, meta } = await apiCommon<IDietDietaryTag[]>(`${groupPrefixDietary}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { model_type }, { created_at: EApiSortType.DESC }),
		})
		return { data: data.map(d => DietDietaryTag(d)), meta }
	},
	createDietaryTag: async (payload: IDietTagCreatePayload): Promise<IDietDietaryTagModel> => {
		const { data } = await apiCommon<IDietDietaryTag>(`${groupPrefixDietary}`, {
			method: 'POST',
			body: dietTagCreateToJSON(payload),
		})

		return DietDietaryTag(data)
	},
	updateDietaryTag: async (body: IDietDietaryTag) => {
		const { data } = await apiCommon<IDietFilterTag>(`${groupPrefixDietary}/${body.id}`, {
			method: 'PUT',
			body,
		})

		return DietMarketingTag(data)
	},
	deleteDietaryTag: async (id: number) => {
		await apiCommon<string>(`${groupPrefixDietary}/${id}`, { method: 'DELETE' })
	},
}
